import React, { useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";
import icons from "../../../assets/images/constantIcons";
import toast from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';

const EditCanteen = ({ isOpen, onClose, userData, userId, updateCanteenUser,fetchCateenUsers }) => {

  const formik = useFormik({
    initialValues: {
      first_name: userData?.first_name || "",
      last_name: userData?.last_name || "",
      phone_number: userData?.phone_number || "",
      address: userData?.address || "",
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required("First name is required"),
      last_name: Yup.string().required("Last name is required"),
      phone_number: Yup.string().required("Phone number is required"),
    }),
    onSubmit: async (values) => {
      try {
        const formData = new FormData();
        formData.append("canteen_user[first_name]", values.first_name);
        formData.append("canteen_user[last_name]", values.last_name);
        formData.append("canteen_user[address]", values.address);
        formData.append("canteen_user[phone_number]", values.phone_number);

      const response = await apiService.put(`/canteen_users/${userId}`, formData);
        onClose();
        toast.success("User updated successfully!", { duration: 2000 });
        updateCanteenUser(response.canteen_user);
        fetchCateenUsers();
      } catch (errors) {
        handleError(errors);
      }
    },
    enableReinitialize: true,
  });

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg p-4 s:p-6 w-[310px] s:w-[350px] md:w-[460px] h-auto overflow-y-auto relative">

        {/* Close Button */}
        <div
          className="absolute top-7 right-3 bg-green50 rounded-full p-2 cursor-pointer w-[32px] h-[32px]"
          onClick={onClose}
        >
          <icons.IoClose className="text-green700" />
        </div>

        <h2 className="text-xl font-semibold mb-5 text-G500 text-start">
          Edit User
        </h2>

        <form onSubmit={formik.handleSubmit} className="space-y-4 text-start">

          {/* First Name */}
          <div className="text-G300">
            <label className="block text-sm mb-2">First Name</label>
            <input
              type="text"
              name="first_name"
              value={formik.values.first_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="inputtext"
              placeholder="First Name"
            />
            {formik.errors.first_name && formik.touched.first_name && (
              <div className="text-red text-sm">{formik.errors.first_name}</div>
            )}
          </div>

          {/* Last Name */}
          <div className="text-G300">
            <label className="block text-sm mb-2">Last Name</label>
            <input
              type="text"
              name="last_name"
              value={formik.values.last_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="inputtext"
              placeholder="Last Name"
            />
            {formik.errors.last_name && formik.touched.last_name && (
              <div className="text-red text-sm">{formik.errors.last_name}</div>
            )}
          </div>

          {/* Phone Number */}
          <div className="text-G300">
            <label className="block text-sm mb-2">Mobile Number</label>
            <PhoneInput
              country={'in'}
              value={formik.values.phone_number}
              onChange={(value) => formik.setFieldValue('phone_number', value)}
              onBlur={formik.handleBlur}
              disableDropdown
              enableSearch={false}
              countryCodeEditable={false}
              onlyCountries={['in']}
              placeholder="80679 35463"
              inputProps={{
                name: 'phone_number',
                required: true,
                className: 'w-full inputtext',
              }}
              buttonStyle={{ display: 'none' }}
            />
            {formik.errors.phone_number && formik.touched.phone_number && (
              <div className="text-red text-sm">{formik.errors.phone_number}</div>
            )}
          </div>

          {/* Address */}
          <div className="text-G300">
            <label className="block text-sm mb-2">Address</label>
            <input
              type="text"
              name="address"
              value={formik.values.address}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="inputtext"
              placeholder="Address"
            />
          </div>

          {/* Buttons */}
          <div className="flex justify-end space-x-4 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="w-[75px] sm:w-[93px] text-sm py-2 text-center border border-green text-green rounded-lg"
            >
              Close
            </button>
            <button
              type="submit"
              className="w-[75px] sm:w-[93px] text-sm text-center py-2 bg-green text-white rounded-lg"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditCanteen;
